import { ChangeEvent, useState } from 'react';

import { Box, Button, Checkbox, Chip, FormControlLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Dialog } from './Dialog';

export const GLOBAL_TOGGLE_CLIENT_DIALOG_HIDE_SESSION_STORAGE =
  'global-toggle-client-dialog-hide';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: '1px',
    transform: 'scale(1.25)',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
}));

export const GlobalToggleClientDialog = ({
  open,
  onConfirm,
  onClose,
}: Props) => {
  const [checked, setChecked] = useState(false);
  const classes = useStyles();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Chip
        size="small"
        color="success"
        label="New"
        sx={{
          fontSize: '0.75rem',
          mr: '0.75rem',
        }}
      />
      Viewing tab as client
    </Box>
  );

  const content = (
    <>
      <Box mb="1rem">
        You are &apos;Viewing tab as client&apos; for this tab only. When you
        open new browser tabs to view content, they will be shown in the PwC
        view. You will need to switch the view in each individual tab to
        &apos;View tab as Client&apos;, if you want to see the client view.
      </Box>

      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            classes={{ root: classes.root }}
            onChange={handleChange}
            inputProps={{ 'aria-label': `Got it, don't show again` }}
          />
        }
        label={`Got it, don't show again`}
      />
    </>
  );
  const actions = (
    <>
      <Button variant="text" size="large" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
          if (checked) {
            window.sessionStorage.setItem(
              GLOBAL_TOGGLE_CLIENT_DIALOG_HIDE_SESSION_STORAGE,
              'true'
            );
          }
          onConfirm();
        }}
      >
        Continue
      </Button>
    </>
  );

  return (
    <Dialog
      content={content}
      title={title}
      open={open}
      actions={actions}
      onClose={onClose}
    />
  );
};
